import { render, staticRenderFns } from "./AppPower.vue?vue&type=template&id=63220ff1"
import script from "./AppPower.vue?vue&type=script&lang=js"
export * from "./AppPower.vue?vue&type=script&lang=js"
import style0 from "./AppPower.vue?vue&type=style&index=0&id=63220ff1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports